import Icon from '../components/Icon.vue'

Icon.register({
  'comment-dollar': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M256 32C114.6 32 0 125.1 0 240 0 289.6 21.4 335 57 370.7 44.5 421.1 2.7 466 2.2 466.5A8-8 0 0 1 8 480C74.3 480 124 448.3 148.6 428.6 181.3 440.9 217.6 448 256 448 397.4 448 512 354.9 512 240S397.4 32 256 32zM280 334.4V352C280 360.8 272.8 368 264 368H248C239.2 368 232 360.8 232 352V334.3C220.6 332.9 209.7 329.1 200.2 322.8 194 318.7 193.4 309.7 198.7 304.4L216.2 286.9C219.9 283.2 225.5 282.7 230.3 284.9 233.5 286.3 237 287.1 240.6 287.1H273.3C278 287.1 281.8 283.3 281.8 278.7 281.8 274.9 279.3 271.6 275.7 270.6L225.6 256.3C203.3 249.9 185.6 231.6 182.7 208.6 178.6 176.5 201.7 149.2 232 145.6V128C232 119.2 239.2 112 248 112H264C272.8 112 280 119.2 280 128V145.7C291.4 147.1 302.3 150.9 311.8 157.2 318 161.3 318.6 170.3 313.3 175.6L295.8 193.1C292.1 196.8 286.5 197.3 281.7 195.1A24.5-24.5 0 0 1 271.4 192.9H238.7C234 192.9 230.2 196.7 230.2 201.3 230.2 205.1 232.7 208.4 236.3 209.4L286.4 223.7C308.7 230.1 326.4 248.4 329.3 271.4 333.4 303.5 310.3 330.8 280 334.4z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/comment-dollar.js
// module id = 5zke
// module chunks = 144